import { getGeo, getActiveGroups } from './onetrust';
import { detectFramework } from './consent-utils';
import { ConsentState } from '@/features/consent/shared/state/consent-slice';

export function buildConsentSnapshot(): ConsentState {
  const { country, state } = getGeo();
  const activeGroups = getActiveGroups();

  return {
    ready: true,
    country: country,
    state: state,
    framework: detectFramework(country, state),
    activeGroups: activeGroups,
  };
}
